import { createSlice } from "@reduxjs/toolkit";

import { getStoredState, setStoredState } from "../storedState";

import { requestSummary_Aggregated } from "../requests/thunks/requestSummary_Aggregated";
import { requestEmailUterum } from "../requests/thunks/requestEmailUterum";

const BFC_SPA_Key = "BFC_SPA_Key";
const storedKey = getStoredState(BFC_SPA_Key);
const initialState = { Key: storedKey || "" };

const handleKeyResponse = (state, action) => {
  const { Key } = action.payload;

  setStoredState(BFC_SPA_Key, Key);

  state.Key = Key;
};

const MiscSlice = createSlice({
  name: "Misc",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(requestSummary_Aggregated.fulfilled, handleKeyResponse)
      .addCase(requestEmailUterum.fulfilled, handleKeyResponse);
  },
});

export default MiscSlice.reducer;
